import { isNumber } from 'lodash';
import React from 'react';
import useCurrentUser from '../../../data/hooks/useCurrentUser';
import useOrganisationGroupName from '../../../data/hooks/useOrganisationGroupName';
import programIntakeOrgStructLevelsSelector from '../../../data/programIntakeOrgStructLevelsSelector.graphql';
import { adapter, selectionFilter, } from '../../containers/EntityForm/fields/OrganisationsTreeSelectorField';
import useLabel from '../../utils/Translations/useLabel';
import GqlStaticTreeSelector from './GqlStaticTreeSelector';
import useResetOnDeps from './hooks/useResetOnDeps';
import { resolveNodeClassName } from '../../adapters/OrganisationTreeAdapter';
import { isRootNode } from '../../dataViews/DynamicTree';
import Button from '../Button';
import useT from '../../utils/Translations/useT';
const IntakeOrganisationLevelsTreeSelector = ({ intakeId, disabled, onChange, title, ...rest }) => {
    const t = useT();
    const { me: { organisationGroupId }, } = useCurrentUser();
    const orgGroupName = useOrganisationGroupName(organisationGroupId);
    const _title = useLabel('Organisation', title);
    useResetOnDeps({ intakeId }, onChange, []);
    const renderNodeAddons = (node, meta) => {
        const { handleClear } = meta;
        const handleClearFn = e => {
            handleClear();
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        };
        const addons = [];
        if (isRootNode(node)) {
            addons.push(<Button additionClasses="text-primary no-padding-top no-padding-bottom" buttonStyle="link" onClick={handleClearFn}>
          {t('Clear')}
        </Button>);
        }
        return addons;
    };
    return (<GqlStaticTreeSelector hasFilter hasSyntheticRootNode initialSelectAll adapter={{
        ...adapter,
        renderNodeAddons,
        resolveNodeClassName,
    }} disabled={!isNumber(intakeId) || disabled} gql={programIntakeOrgStructLevelsSelector} gqlSkip={!isNumber(intakeId)} gqlVariables={{ intakeId }} hasClearButton={false} selectionFilter={selectionFilter} syntheticRootNodeName={orgGroupName} title={_title} onChange={onChange} {...rest}/>);
};
export default IntakeOrganisationLevelsTreeSelector;
